module.exports = __webpack_public_path__ + "img/fire.33d14b30.svg";